import { render } from "./SuperAdminLayout.vue?vue&type=template&id=0bef99a2"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js"

import "./SuperAdminLayout.vue?vue&type=style&index=0&id=0bef99a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__